import React from 'react'

const Table = ({ headers, rows }) => (
  <div className="overflow-x-auto">
    <div className="flex items-center justify-center overflow-hidden break-all">
      <div className="shadow-md rounded my-6">
        <table className="table-fixed">
          <thead>
            <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
              {headers.map((header) => (
                <th className="py-3 px-6 w-3/12 text-center">{header}</th>
              ))}
            </tr>
          </thead>
          <tbody className="text-gray-600 text-sm font-light">
            {rows.map((row) => (
              <tr className="border-b border-gray-200  bg-white hover:bg-gray-100">
                {row.map((cell) => (
                  <td className="py-3 px-6 text-left">
                    <div className="flex items-center justify-evenly">{cell}</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)

export default Table
